import { createContext, useContext } from 'react'

const PforExclusionContext = createContext<string[]>([])

/**
 * Provides the DB-backed list of storefront IDs that have PFOR hidden
 * (`getExcludedPforStorefrontIds()`, fetched in `getServerSideProps`) to every
 * PFOR display component and analytics hook on the Listing Detail Page.
 */
export const PforExclusionProvider = ({
  children,
  excludedPforStorefrontIds,
}: {
  children: React.ReactNode
  excludedPforStorefrontIds: string[]
}) => {
  return (
    <PforExclusionContext.Provider value={excludedPforStorefrontIds}>
      {children}
    </PforExclusionContext.Provider>
  )
}

/** Defaults to [] outside a provider, so PFOR is shown rather than always hidden. */
export const useExcludedPforStorefrontIds = (): string[] => {
  return useContext(PforExclusionContext)
}
